import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import MarketplaceHexIcon from './MarketplaceHexIcon';
import MarketplaceSummaryScroll from './MarketplaceSummaryScroll';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

function getStatus(component) {
  if (component.status === 'new' || component.status === 'NEW') {
    return { label: 'New', variant: 'new' };
  }
  if (component.status === 'stable' || component.status === 'STABLE') {
    return { label: 'Stable', variant: 'stable' };
  }
  const created = component.createdAt ? new Date(component.createdAt).getTime() : 0;
  if (created && Date.now() - created < THIRTY_DAYS_MS) {
    return { label: 'New', variant: 'new' };
  }
  return { label: 'Stable', variant: 'stable' };
}

function MarketplaceItemCard({ component }) {
  const navigate = useNavigate();
  const status = getStatus(component);
  const summaryText = component.description || component.summary || 'No summary provided.';

  const onAddToWorkflow = () => {
    navigate('/workspace/workflow-creator', {
      state: { marketplaceComponent: component },
    });
  };

  return (
    <article className='marketplace-card'>
      <header className='marketplace-card__header'>
        <MarketplaceHexIcon name={component.name} iconUrl={component.icon} />
        <div className='marketplace-card__heading'>
          <h3 className='marketplace-card__title'>{component.name}</h3>
          <span className={`marketplace-card__badge marketplace-card__badge--${status.variant}`}>
            {status.label}
          </span>
        </div>
      </header>

      <div className='marketplace-card__divider' />

      <section className='marketplace-card__body'>
        <p className='marketplace-card__label'>Summary</p>
        <MarketplaceSummaryScroll>
          <div className='marketplace-card__summary-text'>
            <ReactMarkdown>{summaryText}</ReactMarkdown>
          </div>
        </MarketplaceSummaryScroll>
      </section>

      <footer className='marketplace-card__footer'>
        <Button type='primary' block className='marketplace-card__cta' onClick={onAddToWorkflow}>
          Add to Workflow
        </Button>
      </footer>
    </article>
  );
}

export default MarketplaceItemCard;
